module.exports = __webpack_public_path__ + "static/media/phone_gold.610a3112.svg";